import { render, staticRenderFns } from "./CourseInfoGeneral.vue?vue&type=template&id=cb7dedee&"
import script from "./CourseInfoGeneral.vue?vue&type=script&lang=js&"
export * from "./CourseInfoGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports